module.exports = __webpack_public_path__ + "img/smg49_samurai01skin_shop.3a1e7f98.png";